/**************************** 管理相關 ****************************/
// 登入
export const API_POST_AUTH_LOGIN = `${process.env.APIPATH}/api/auth/login`;
// 登出
export const API_POST_AUTH_LOGOUT = `${process.env.APIPATH}/api/auth/logout`;
// 更改密碼
export const API_POST_AUTH_UPDATE_PASSWORD = `${process.env.APIPATH}/api/auth/update_password`;
// 查詢帳號權限
export const API_GET_ADMIN = `${process.env.APIPATH}/api/admin`;
// 更新帳號權限
export const API_PUT_ADMIN = `${process.env.APIPATH}/api/admin`;

/**************************** 契約相關 ****************************/
// 查詢契約
export const API_GET_MEMBER = `${process.env.APIPATH}/api/member`;
// 新增契約
export const API_POST_MEMBER = `${process.env.APIPATH}/api/member`;
// 更新契約
export const API_PUT_MEMBER = `${process.env.APIPATH}/api/member`;
// 刪除契約
export const API_DELETE_MEMBER = `${process.env.APIPATH}/api/member`;
// 更新契約狀態
export const API_UPDATE_STATUS = `${process.env.APIPATH}/api/update_status`;
// 查詢互助
export const API_GET_HELP = `${process.env.APIPATH}/api/help`;
// 查詢互助身故名單
export const API_GET_DEAD_LIST = `${process.env.APIPATH}/api/dead_list`;
// 查詢遞延
export const API_GET_DEFERRED = `${process.env.APIPATH}/api/deferred`;
// 匯出契約EXCEL
export const API_GET_EXPORT_MEMBER = `${process.env.APIPATH}/api/export_member`;
// 匯出分紅制度報表
export const API_GET_EXPORT_REPORT_DIVIDEND = `${process.env.APIPATH}/api/export_report_dividend`;
// 查詢契約LOG
export const API_GET_MEMBERS_LOGS = `${process.env.APIPATH}/api/members_logs`;
// 重設理賠
export const API_POST_CLAIM_MEMBERS = `${process.env.APIPATH}/api/claim_member`;
// 上傳身故證明圖片
export const API_POST_UPLOAD_CLAIM_IMAGE = `${process.env.APIPATH}/api/upload_claim_image`;
// 查詢顯示於前台契約
export const API_GET_DISPLAY_MEMBER = `${process.env.APIPATH}/api/get_display_member`;
// 查詢設定自動扣款資料
export const API_GET_SET_AUTO_APPLY = `${process.env.APIPATH}/api/set_auto_apply`;

/**************************** 契約促銷設定相關 ****************************/
// 查詢契約促銷設定
export const API_GET_PROMOTION = `${process.env.APIPATH}/api/promotion`;
// 新增契約促銷設定
export const API_POST_PROMOTION = `${process.env.APIPATH}/api/promotion`;
// 更新契約促銷設定
export const API_PUT_PROMOTION = `${process.env.APIPATH}/api/promotion`;
// 刪除契約促銷設定
export const API_DELETE_PROMOTION = `${process.env.APIPATH}/api/promotion`;

/**************************** 預領相關 ****************************/
// 查詢預領
export const API_GET_Loan = `${process.env.APIPATH}/api/loan`;
// 新增預領
export const API_POST_Loan = `${process.env.APIPATH}/api/loan`;
// 更新預領
export const API_PUT_Loan = `${process.env.APIPATH}/api/loan`;
// 刪除預領
export const API_DELETE_Loan = `${process.env.APIPATH}/api/loan`;

/**************************** 業務相關 ****************************/
// 查詢業務
export const API_GET_SALES = `${process.env.APIPATH}/api/sales`;
// 新增業務
export const API_POST_SALES = `${process.env.APIPATH}/api/sales`;
// 更新業務
export const API_PUT_SALES = `${process.env.APIPATH}/api/sales`;
// 刪除業務
export const API_DELETE_SALES = `${process.env.APIPATH}/api/sales`;
// 匯出業務EXCEL
export const API_GET_EXPORT_SALES = `${process.env.APIPATH}/api/export_sales`;
// 查詢業務上層樹狀圖
export const API_POST_SALES_UPPER_TREE = `${process.env.APIPATH}/api/sales_upper_tree`;
// 查詢業務下層樹狀圖
export const API_POST_SALES_LOWER_TREE = `${process.env.APIPATH}/api/sales_tree`;
// 查詢業務LOG
export const API_GET_SALES_LOGS = `${process.env.APIPATH}/api/sales_logs`;
// 重新載入業務聘階
export const API_GET_REFRESH_RANK = `${process.env.APIPATH}/api/refresh_rank`;

/**************************** 帳單相關 ****************************/
// 查詢帳單
export const API_GET_BILL = `${process.env.APIPATH}/api/bill`;
// 新增帳單
export const API_POST_BILL = `${process.env.APIPATH}/api/bill`;
// 更新帳單
export const API_PUT_BILL = `${process.env.APIPATH}/api/bill`;
// 刪除帳單
export const API_DELETE_BILL = `${process.env.APIPATH}/api/bill`;
// 查詢帳單(攤平)
export const API_GET_BILL_FLATTEN = `${process.env.APIPATH}/api/bill_flatten`;
// 銷帳單
export const API_POST_REMOVE_BILL = `${process.env.APIPATH}/api/remove_bill`;
// 多筆銷帳單
export const API_POST_MULTI_REMOVE_BILL = `${process.env.APIPATH}/api/multi_remove_bill`;
// 匯出EXCEL
export const API_GET_EXPORT_BILL = `${process.env.APIPATH}/api/export_bill`;
// 批次銷帳
export const API_GET_BATCH_REMOVE_BILL = `${process.env.APIPATH}/api/batch_remove_bill`;
// 查詢帳單報表
export const API_GET_BILL_REPORT = `${process.env.APIPATH}/api/bill_report`;
// 產生帳單
export const API_POST_OUTPUT_BILL = `${process.env.APIPATH}/api/output_bill`;
// 查詢帳單LOG
export const API_GET_BILLS_LOGS = `${process.env.APIPATH}/api/bills_logs`;
// 查詢2期催繳通知
export const API_GET_URGE_BILL = `${process.env.APIPATH}/api/urge_bill`;
// 查詢設定自動扣款資料
export const API_GET_SET_AUTO_BILL = `${process.env.APIPATH}/api/set_auto_bill`;
// 批次銷自動扣款帳單
export const API_GET_BATCH_REMOVE_AUTO_BILL = `${process.env.APIPATH}/api/batch_remove_auto_bill`;
// 批次銷帳單(台中商銀)
export const API_GET_BATCH_REMOVE_BANK_BILL = `${process.env.APIPATH}/api/batch_remove_bank_bill`;

/**************************** 報表相關 ****************************/
// 匯出入會費、報聘費excel
export const API_GET_EXPORT_JOIN_FEE = `${process.env.APIPATH}/api/export_join_fee`;
// 取得每月新增人數
export const API_GET_REPORT_MONTH_ADD = `${process.env.APIPATH}/api/report_month_add`;
// 取得每月身故理賠人數
export const API_GET_REPORT_MONTH_PAY = `${process.env.APIPATH}/api/report_month_pay`;
// 取得每月統計
export const API_GET_REPORT_MONTH_STATISTICAL = `${process.env.APIPATH}/api/report_month_statistical`;
// 匯出每月人數
export const API_GET_EXPORT_REPORT_MONTH = `${process.env.APIPATH}/api/export_report_month`;
// 取得每月繳滿人數
export const API_GET_REPORT_MONTH_PAY_OFF = `${process.env.APIPATH}/api/report_month_pay_off`;
// 取得契約各組相關數據總表
export const API_GET_REPORT_ALL_MEMBER = `${process.env.APIPATH}/api/report_all_member`;
// 取得帳單相關數據總表
export const API_GET_REPORT_ALL_BILL = `${process.env.APIPATH}/api/report_all_bill`;
// 取得每月件數一覽
export const API_GET_REPORT_MONTH_MEMBER = `${process.env.APIPATH}/api/report_month_member`;
// 取得互助人年齡層
export const API_GET_REPORT_MEMBER_AGE = `${process.env.APIPATH}/api/report_member_age`;
// 取得業務年齡層
export const API_GET_REPORT_SALES_AGE = `${process.env.APIPATH}/api/report_sales_age`;
// 取得失效會員繳款次數
export const API_GET_REPORT_MEMBER_EXCLUSION_PAYCOUNT = `${process.env.APIPATH}/api/report_member_exclusion_paycount`;
// 取得身故會員理賠分布
export const API_GET_REPORT_CLAIM_MEMBER = `${process.env.APIPATH}/api/report_claim_member`;

/**************************** 舊系統-操作日誌相關 ****************************/
// 查詢舊系統-契約LOG
export const API_GET_OLD_1_7_LOGS = `${process.env.APIPATH}/api/old_1_7_logs`;
// 查詢舊系統-查詢契約繳費通知地址LOG
export const API_GET_OLD_1_8_LOGS = `${process.env.APIPATH}/api/old_1_8_logs`;
// 查詢舊系統-入會費LOG
export const API_GET_OLD_2_7_LOGS = `${process.env.APIPATH}/api/old_2_7_logs`;
// 查詢舊系統-互助金LOG
export const API_GET_OLD_3_7_LOGS = `${process.env.APIPATH}/api/old_3_7_logs`;
// 查詢舊系統-業務LOG
export const API_GET_OLD_5_7_LOGS = `${process.env.APIPATH}/api/old_5_7_logs`;

/**************************** 訂單相關 ****************************/
// 查詢訂單
export const API_GET_ORDER = `${process.env.APIPATH}/api/order`;
// 新增訂單
export const API_POST_ORDER = `${process.env.APIPATH}/api/order`;
// 更新訂單
export const API_PUT_ORDER = `${process.env.APIPATH}/api/order`;
// 匯出詳細訂單EXCEL
export const API_GET_ORDER_DETAIL = `${process.env.APIPATH}/api/export_order_detail`;

/**************************** 要助人相關 ****************************/
// 查詢要助人個人資訊
export const API_GET_HELPING_PERSONAL_INFO = `${process.env.APIPATH}/api/member`;
// 查詢要助人契約
export const API_GET_HELPING_MEMBER = `${process.env.APIPATH}/api/member`;
// 查詢繳費列表
export const API_GET_PAY = `${process.env.APIPATH}/api/bill`;

/**************************** 業務人相關 ****************************/
// 查詢業務人個人資訊
export const API_GET_BUSINESS_PERSONAL_INFO = `${process.env.APIPATH}/api/sales`;
// 查詢直推契約
export const API_GET_DIRECT_PUSH_CONTRACT = `${process.env.APIPATH}/api/bill`;
// 查詢直推回歸件
export const API_GET_DIRECT_PUSH_RETURN_PIECE = `${process.env.APIPATH}/api/bill`;
// 查詢業務樹狀圖
export const API_POST_SALES_TREE = `${process.env.APIPATH}/api/sales_tree`;
// 查詢直推會員未繳明細表
export const API_GET_DIRECT_PUSH_MEMBER_UNPAID = `${process.env.APIPATH}/api/bill`;

/**************************** 環境設定相關 ****************************/
// 查詢環境設定
export const API_GET_CONFIG = `${process.env.APIPATH}/api/config`;
// 更新環境設定
export const API_PUT_CONFIG = `${process.env.APIPATH}/api/config`;
// 更新多筆環境設定
export const API_POST_MULTI_UPDATE_CONFIG = `${process.env.APIPATH}/api/multi_update_config`;



// WEBPACK FOOTER //
// ./src/models/API/apiUrl.js